import {
  natureIcon,
  farmIcon,
  familyIcon,
  islandsIcon,
  italyIcon,
  spainIcon,
  colombiaIcon,
  indonesiaIcon,
  ecuadorIcon,
  namibiaIcon,
  starIcon,
  europeIcon,
  animalsIcon,
  backPackIcon,
} from './categoryIcons';
import { mostBookedIcon } from '../../ListingSection/data/categoryIcons';
import chosenCarefullyIcon from './icons/chosen_carefully.png';
import copilotIcon from './icons/copilot.png';
import travelAuthenticIcon from './icons/travel_authentic.png';
import local2Icon from './icons/local2.png';

export const multidayCategoryData = [
  {
    id: 1,
    messageId: 'landing.accomodations.popular',
    categoryIcon: mostBookedIcon,
    name: 'popular',
  },
  {
    id: 9,
    messageId: 'ListingSection.category.personalOffer',
    categoryIcon: chosenCarefullyIcon,
    name: 'personalOffer',
    hasModal: true,
  },
  {
    id: 2,
    messageId: 'landing.accomodations.europe',
    categoryIcon: europeIcon,
    name: 'europe',
  },
  {
    id: 3,
    messageId: 'landing.accomodations.marineLife',
    categoryIcon: copilotIcon,
    name: 'marine-life',
  },
  {
    id: 4,
    messageId: 'landing.accomodations.wildlife',
    categoryIcon: animalsIcon,
    name: 'wildlife',
  },
  {
    id: 5,
    messageId: 'landing.accomodations.roundtrip',
    categoryIcon: travelAuthenticIcon,
    name: 'roundtrip',
  },
  {
    id: 6,
    messageId: 'landing.accomodations.getaway',
    categoryIcon: backPackIcon,
    name: 'getaway',
  },
  {
    id: 7,
    messageId: 'landing.accomodations.longTerm',
    categoryIcon: local2Icon,
    name: 'long-term',
  },
];

export const uniqueAccomodationCategoryData = [
  {
    id: 0,
    messageId: 'landing.accomodations.categoryDefault',
    categoryIcon: starIcon,
    name: 'stays',
  },
  {
    id: 1,
    messageId: 'landing.accomodations.italy',
    categoryIcon: italyIcon,
    name: 'italy',
  },
  {
    id: 2,
    messageId: 'landing.accomodations.spain',
    categoryIcon: spainIcon,
    name: 'spain',
  },
  {
    id: 3,
    messageId: 'landing.accomodations.colombia',
    categoryIcon: colombiaIcon,
    name: 'colombia',
  },
  {
    id: 4,
    messageId: 'landing.accomodations.indonesia',
    categoryIcon: indonesiaIcon,
    name: 'indonesia',
  },
  {
    id: 5,
    messageId: 'landing.accomodations.ecuador',
    categoryIcon: ecuadorIcon,
    name: 'ecuador',
  },
  {
    id: 6,
    messageId: 'landing.accomodations.namibia',
    categoryIcon: namibiaIcon,
    name: 'namibia',
  },
  {
    id: 7,
    messageId: 'landing.accomodations.category8',
    categoryIcon: farmIcon,
    name: 'farm',
  },
  {
    id: 8,
    messageId: 'landing.accomodations.category4',
    categoryIcon: natureIcon,
    name: 'nature',
  },
  {
    id: 9,
    messageId: 'landing.accomodations.category2',
    categoryIcon: familyIcon,
    name: 'family',
  },
  {
    id: 10,
    messageId: 'landing.accomodations.category15',
    categoryIcon: islandsIcon,
    name: 'islands',
  },
];
